import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

const PROMO_LEVELS = [
  { value: 'free', label: '免费推广员', color: '#13c2c2', fee: '免费注册', commission: '30%' },
  { value: 'deposit', label: '保证金推广员', color: '#722ed1', fee: '¥1,000保证金', commission: '40%' },
  { value: 'certified', label: '认证推广员', color: '#fa8c16', fee: '¥5,000保证金', commission: '50%' },
]

export default function Partners() {
  const [partners, setPartners] = useState([])
  const [commissions, setCommissions] = useState([])
  const [tab, setTab] = useState('partners')
  const [loading, setLoading] = useState(true)
  const [showAdd, setShowAdd] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState({ name: '', phone: '', promoType: 'free', idCard: '', address: '' })

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    setLoading(true)
    Promise.all([
      fetch(`${API}/partner-dashboard/partners`).then(r => r.json()),
      fetch(`${API}/partners/list`).then(r => r.json()).catch(() => ({ success: true, data: [] }))
    ]).then(([dashboard]) => {
      if (dashboard.success) {
        setPartners(dashboard.data || [])
        setCommissions(dashboard.commissions || [])
      }
    }).catch(() => {
      setPartners([])
      setCommissions([])
    }).finally(() => setLoading(false))
  }

  const handleSubmit = async () => {
    if (!form.name.trim()) { alert('请输入姓名'); return }
    if (!form.phone || !/^1\d{10}$/.test(form.phone)) { alert('请输入正确的手机号'); return }
    
    setSaving(true)
    try {
      const promoLevel = PROMO_LEVELS.find(p => p.value === form.promoType) || PROMO_LEVELS[0]
      const commissionRate = form.promoType === 'certified' ? 50 : form.promoType === 'deposit' ? 40 : 30
      const res = await fetch(`${API}/partners`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, level: promoLevel.label, commission_rate: commissionRate, promo_type: form.promoType })
      })
      const d = await res.json()
      if (d.success) {
        setModalVisible(false)
        loadData()
        alert('推广员添加成功！')
      } else {
        alert(d.error || '添加失败')
      }
    } catch (e) {
      alert('添加失败')
    }
    setSaving(false)
  }

  const toggleStatus = async (partner) => {
    const newStatus = partner.status === 'active' ? 'disabled' : 'active'
    if (!confirm(`确定${newStatus === 'active' ? '启用' : '禁用'}推广员 ${partner.name}？`)) return
    try {
      const res = await fetch(`${API}/partners/update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: partner.id, status: newStatus })
      })
      const data = await res.json()
      if (data.success) { loadData() } else { alert(data.error || '更新失败') }
    } catch (err) { alert('更新失败') }
  }

  const getLevelBadge = (level) => {
    const levelObj = PROMO_LEVELS.find(p => p.label === level || p.value === level)
    if (levelObj) {
      return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: levelObj.color, color: '#fff' }}>{levelObj.label}</span>
    }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#999', color: '#fff' }}>{level}</span>
  }

  if (loading) return <div style={{ padding: 40 }}>加载中...</div>

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>👥 推广员管理</h2>
        <div style={{ display: 'flex', gap: 12 }}>
          <button onClick={() => { window.location.assign('/cms/?page=partner-register') }}
            style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
            📝 推广员申请
          </button>
          <button onClick={() => setModalVisible(true)}
            style={{ padding: '10px 20px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
            + 添加推广员
          </button>
        </div>
      </div>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>推广员总数</div>
          <div style={{ fontSize: 28, color: '#1890ff' }}>{partners.length}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>免费推广员</div>
          <div style={{ fontSize: 28, color: '#13c2c2' }}>{partners.filter(p => p.level === '免费推广员' || p.promo_type === 'free').length}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>保证金推广员</div>
          <div style={{ fontSize: 28, color: '#722ed1' }}>{partners.filter(p => p.level === '保证金推广员' || p.promo_type === 'deposit').length}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>认证推广员</div>
          <div style={{ fontSize: 28, color: '#fa8c16' }}>{partners.filter(p => p.level === '认证推广员' || p.promo_type === 'certified').length}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>累计佣金</div>
          <div style={{ fontSize: 28, color: '#f5222d' }}>¥{partners.reduce((s, p) => s + (p.totalCommission || 0), 0).toLocaleString()}</div>
        </div>
      </div>

      {/* 佣金说明 */}
      <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: 16, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#52c41a', marginBottom: 8 }}>💡 佣金比例说明（当前政策）</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, fontSize: 13 }}>
          {PROMO_LEVELS.map(t => (
            <div key={t.value} style={{ padding: 12, background: '#fff', borderRadius: 8 }}>
              <div style={{ color: t.color, fontWeight: 600, fontSize: 14 }}>{t.label}</div>
              <div style={{ color: '#666', marginTop: 4 }}>{t.fee}</div>
              <div style={{ color: '#666', marginTop: 2 }}>七彩故事工坊佣金: {t.commission}</div>
              <div style={{ color: '#666' }}>AI动画佣金: {t.commission}</div>
              <div style={{ color: '#52c41a', marginTop: 4, fontSize: 12 }}>管理奖: 下级佣金的20%</div>
            </div>
          ))}
        </div>
      </div>

      {/* 标签页 */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <button onClick={() => setTab('partners')}
          style={{ ...tabBtn, background: tab === 'partners' ? '#1890ff' : '#f5f5f5', color: tab === 'partners' ? '#fff' : '#666' }}>
          推广员列表
        </button>
        <button onClick={() => setTab('commissions')}
          style={{ ...tabBtn, background: tab === 'commissions' ? '#1890ff' : '#f5f5f5', color: tab === 'commissions' ? '#fff' : '#666' }}>
          佣金记录
        </button>
      </div>

      {tab === 'partners' ? (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={th}>编号</th>
                <th style={th}>姓名</th>
                <th style={th}>手机</th>
                <th style={th}>级别</th>
                <th style={th}>佣金比例</th>
                <th style={th}>下线</th>
                <th style={th}>累计佣金</th>
                <th style={th}>推荐人</th>
                <th style={th}>状态</th>
                <th style={th}>操作</th>
              </tr>
            </thead>
            <tbody>
              {partners.map(p => (
                <tr key={p.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{p.id}</td>
                  <td style={{ ...td, fontWeight: 500 }}>{p.name}</td>
                  <td style={td}>{p.phone}</td>
                  <td style={td}>{getLevelBadge(p.level || p.promo_type)}</td>
                  <td style={{ ...td, color: '#52c41a' }}>{p.commissionRate || p.commission_rate || 30}%</td>
                  <td style={td}>{p.下线数 || 0}人</td>
                  <td style={{ ...td, color: '#f5222d', fontWeight: 600 }}>¥{(p.totalCommission || 0).toLocaleString()}</td>
                  <td style={td}>{p.referrer || p.parent_id || '-'}</td>
                  <td style={td}>
                    <span style={{ color: p.status === 'active' ? '#52c41a' : '#999' }}>
                      {p.status === 'active' ? '活跃' : '已禁用'}
                    </span>
                  </td>
                  <td style={td}>
                    <button onClick={() => toggleStatus(p)}
                      style={{ padding: '4px 8px', background: p.status === 'active' ? '#ff4d4f' : '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>
                      {p.status === 'active' ? '禁用' : '启用'}
                    </button>
                  </td>
                </tr>
              ))}
              {partners.length === 0 && (
                <tr><td colSpan={10} style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无数据</td></tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={th}>推广员</th>
                <th style={th}>订单号</th>
                <th style={th}>产品</th>
                <th style={th}>订单金额</th>
                <th style={th}>佣金</th>
                <th style={th}>时间</th>
              </tr>
            </thead>
            <tbody>
              {commissions.map(c => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{c.partnerName}</td>
                  <td style={td}>{c.orderId || c.order_id}</td>
                  <td style={td}>{c.productName || '-'}</td>
                  <td style={{ ...td, color: '#333' }}>¥{c.amount}</td>
                  <td style={{ ...td, color: '#52c41a', fontWeight: 'bold' }}>¥{c.commission}</td>
                  <td style={{ ...td, color: '#999' }}>{c.createdAt || c.created_at}</td>
                </tr>
              ))}
              {commissions.length === 0 && (
                <tr><td colSpan={6} style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无数据</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* 添加推广员弹窗 */}
      {modalVisible && (
        <div style={modalOverlay} onClick={() => setModalVisible(false)}>
          <div style={modalContent} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 20px', fontSize: 18 }}>+ 添加推广员</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={label}>推广类型 *</label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
                {PROMO_LEVELS.map(t => (
                  <div key={t.value}
                    onClick={() => setForm({ ...form, promoType: t.value })}
                    style={{
                      padding: '12px 8px', border: '2px solid',
                      borderColor: form.promoType === t.value ? t.color : '#e8e8e8',
                      background: form.promoType === t.value ? `${t.color}11` : '#fff',
                      borderRadius: 8, cursor: 'pointer', textAlign: 'center'
                    }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: form.promoType === t.value ? t.color : '#666' }}>{t.label}</div>
                    <div style={{ fontSize: 10, color: '#999', marginTop: 2 }}>{t.fee}</div>
                    <div style={{ fontSize: 10, color: '#52c41a' }}>佣金 {t.commission}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>姓名 *</label>
              <input type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="请输入姓名" style={input} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={label}>手机号 *</label>
              <input type="tel" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="请输入11位手机号" maxLength={11} style={input} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={label}>身份证号</label>
              <input type="text" value={form.idCard} onChange={e => setForm({ ...form, idCard: e.target.value })} placeholder="选填" style={input} />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={label}>地址</label>
              <input type="text" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} placeholder="选填" style={input} />
            </div>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setModalVisible(false)}
                style={{ ...btn, background: '#f5f5f5', color: '#666' }}>取消</button>
              <button onClick={handleSubmit} disabled={saving}
                style={{ ...btn, background: '#52c41a', color: '#fff' }}>{saving ? '添加中...' : '添加推广员'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const tabBtn = { padding: '8px 16px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }
const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modalContent = { background: '#fff', borderRadius: 12, padding: 24, width: 480, maxHeight: '80vh', overflowY: 'auto' }
const label = { display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }
const input = { width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }
const btn = { padding: '10px 20px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }
